import { render, staticRenderFns } from "./VerifyEdit.vue?vue&type=template&id=0c1bc363&scoped=true"
import script from "./VerifyEdit.vue?vue&type=script&lang=js"
export * from "./VerifyEdit.vue?vue&type=script&lang=js"
import style0 from "./VerifyEdit.vue?vue&type=style&index=0&id=0c1bc363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1bc363",
  null
  
)

export default component.exports